import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { FixedComponentsRateChartRequest } from "./fixed-components-rate-chart-request";

export class FixedComponentsRateChartResponseModel extends GlobalResponseObject{
    data?:FixedComponentsRateChartRequest[]
     
    constructor(status:boolean, intelCode:number, internalMessage:string ,data?:FixedComponentsRateChartRequest[]){
    super(status,intelCode,internalMessage)
    this.status=status
    this.intlCode=intelCode
    this.internalMessage=internalMessage
    this.data=data
    }

}